module.exports = __webpack_public_path__ + "static/img/header3.914adcf4.jpeg";